import * as getterTypes from '@/store/getter-types'
import * as Config from '@/Config'
import * as LoadingWaitTypes from '@/constants/LoadingWaitTypes'

/**
 * クイズ情報をシュルたリングして取得
 * @param information
 * @param exclusionProc 除外用関数
 * @returns {{qsm_lists: Qsm[][], qm_list: Qm[]}}
 */
const filterInformation = (information, exclusionProc) => {
  const keys = Object.keys(information.qm_list)
  const len = keys.length
  /** @type {Qm[]} */
  let qmList = []
  /** @type {Qsm[][]} */
  let qsmLists = []
  for (let i = 0; i < len; i += 1) {
    const key = keys[i]
    const qm = information.qm_list[key]
    if (exclusionProc(information.uq_list[qm.id])) continue
    qmList.push(qm)
    qsmLists[qm.quiz_selections_masters_group_id] = information.qsm_lists[qm.quiz_selections_masters_group_id]
  }
  return {
    qm_list: qmList,
    qsm_lists: qsmLists
  }
}

export default {
  /**
   * 未回答情報
   * @param state
   * @returns {{qsm_lists: Qsm[][], qm_list: Qm[]}}
   */
  [getterTypes.unansweredInformation] (state) {
    return filterInformation(state.information, (uq) => {
      // データがあり、正解なら回答済み
      return uq !== undefined && uq.correct_flag === 1
    })
  },
  /**
   * 回答済み情報
   * @param state
   * @returns {{qsm_lists: Qsm[][], qm_list: Qm[]}}
   */
  [getterTypes.answeredInformation] (state) {
    return filterInformation(state.information, (uq) => {
      // データがないか、あっても不正解なら未回答扱い
      return uq === undefined || uq.correct_flag === 0
    })
  },
  /**
   * 未ログイン時情報
   * @param state
   * @returns {{qsm_lists: Qsm[][], qm_list: Qm[]}}
   */
  [getterTypes.beforeLoginInformation] (state) {
    return filterInformation(state.information, () => {
    })
  },
  /**
   * クイズリストが未回答状態かを示す
   * @param state
   * @returns {boolean}
   */
  [getterTypes.isUnansweredListView] (state) {
    return state.quiz_list_view === 1
  },
  /**
   * ログイン状態
   * @param state
   * @returns {Document.form_login.is_login|boolean}
   */
  [getterTypes.isLogin] (state) {
    return state.is_login
  },
  /**
   * 正解結果情報
   * @param state
   * @returns {state.result_correct_information|{answer_text, hint_url, text, point}|CorrectInformation}
   */
  [getterTypes.resultCorrectInformation] (state) {
    return state.result_correct_information
  },
  /**
   * 不正解結果情報
   * @param state
   * @returns {IncorrectInformation}
   */
  [getterTypes.resultIncorrectInformation] (state) {
    return state.result_incorrect_information
  },
  /**
   * ページ番号
   * @param state
   * @returns {number|Number}
   */
  [getterTypes.pageNumber] (state) {
    return state.page_number
  },
  /**
   * 最大ページ数
   * @param state
   * @param getters
   * @returns {number}
   */
  [getterTypes.maxPageNumber] (state, getters) {
    let qmListCount = 0
    if (getters.isUnansweredListView) {
      // 未回答リスト
      const keys = Object.keys(getters.unansweredInformation.qm_list)
      qmListCount = keys.length
    } else {
      // 回答済みリスト
      const keys = Object.keys(getters.answeredInformation.qm_list)
      qmListCount = keys.length
    }
    return Math.ceil(qmListCount / Config.VIEW_MAX_LIST_NUMBER)
  },
  /**
   * ポイント
   * @param state
   * @returns {number}
   */
  [getterTypes.point] (state) {
    return state.information.point
  },
  /**
   * ローディング待ち
   * @param state
   * @returns {boolean}
   */
  [getterTypes.isLoadingWait] (state) {
    // １つでもloading中のデータがあればtrue
    const keys = Object.keys(state.loading_waits)
    const len = keys.length
    for (let i = 0; i < len; i += 1) {
      const key = keys[i]
      if (state.loading_waits[key]) {
        return true
      }
    }
    return false
  },
  /**
   * SetUp中
   * @param state
   * @returns {*|boolean}
   */
  [getterTypes.isSetUp] (state) {
    return state.loading_waits[LoadingWaitTypes.INITIALIZE]
  }
}
